/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsBaseForVmwareVcd extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsBaseForVmwareVcd");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsBaseForVmwareVcd.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsBaseForVmwareVcd>): ServiceAccountCredentialsBaseForVmwareVcd {
        let obj = Object.assign(new ServiceAccountCredentialsBaseForVmwareVcd(), model);
        ServiceAccountCredentialsBaseForVmwareVcd.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsBaseForVmwareVcd>): ServiceAccountCredentialsBaseForVmwareVcd {
        if (!model) return null;
        return ServiceAccountCredentialsBaseForVmwareVcd.newInstance(<ServiceAccountCredentialsBaseForVmwareVcd> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsBaseForVmwareVcd) {
        if (!obj) return;

        models.ServiceAccountCredentialsBaseForVmwareVcd.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsBaseForVmwareVcd): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsBaseForVmwareVcd.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Domain. This is a required field.
     */
    domain: string;

    /**
     * API Key. This is a required field.
     */
    api_key: string;

}
